import React, { useState } from "react";
import "../styles/avatarSelect.css";
import PreviewVRM from "./PreviewVRM";
import avatarAssets from "../utils/avatarAssets";
// Analytics imports
import { trackEvent } from '../firebase/analytics';
import { ANALYTICS_EVENTS } from '../firebase/analyticsEvents';

const AvatarSelectPage = ({ onAvatarSelect, onBack }) => {
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  // Always use VRM mode for preview
  const [previewMode, setPreviewMode] = useState("vrm");
  
  // Default featured image is the first avatar
  const [featuredAvatarSrc, setFeaturedAvatarSrc] = useState(() => {
    const firstAvatar = avatarAssets.getAllAvatars()[0];
    return avatarAssets.getAvatarIcon(firstAvatar);
  });

  const avatars = avatarAssets.getAllAvatarsWithAlternatives();
  console.log('[AvatarSelectPage] Available avatars:', avatars);

  const handleAvatarClick = (avatar) => {
    console.log('[AvatarSelectPage] Avatar clicked:', avatar);
    
    trackEvent(ANALYTICS_EVENTS.AVATAR_SELECT_CLICK, {
      avatar_id: avatar.id,
      avatar_type: avatar.type || 'vrm',
      page: 'avatar_select',
      timestamp: Date.now()
    });
    
    // Test VRM path resolution immediately
    const vrmPath = avatarAssets.getVrmPath(avatar);
    console.log('[AvatarSelectPage] VRM path for clicked avatar:', vrmPath);
    
    // Create avatar object with full URLs for both icon and VRM
    const avatarWithFullUrls = {
      ...avatar,
      src: avatarAssets.getAvatarIcon(avatar),
      vrmPath: avatarAssets.getVrmPath(avatar)
    };
    
    console.log('[AvatarSelectPage] Avatar with full URLs:', avatarWithFullUrls);
    
    setSelectedAvatar(avatarWithFullUrls); // Use the avatar with full URLs
    setFeaturedAvatarSrc(avatarAssets.getAvatarIcon(avatar));
    console.log('[AvatarSelectPage] Selected avatar updated to:', avatarWithFullUrls);
    
    // Always use VRM mode for the preview
    setPreviewMode("vrm");
    
    // On mobile screens, proceed automatically after a short delay
    if (window.innerWidth < 768) {
      setTimeout(() => {
        onAvatarSelect(avatarWithFullUrls);
      }, 800); // Increased delay to allow preview to be seen
    }
    // On desktop, user will click the continue button
  };

  return (
    <div className="avatar-select-container">
      <div className="avatar-select-header">
        <div className="header-content">
          <button className="back-btn" onClick={() => {
            trackEvent(ANALYTICS_EVENTS.BACK_BUTTON_CLICK, {
              from_page: 'avatar_select',
              timestamp: Date.now()
            });
            onBack();
          }}>← Back</button>
          <h1>Select your avatar</h1>
        </div>
      </div>
      
      <div className="avatar-select-content">
        {/* Featured Avatar (Left side on desktop) */}
        <div className="featured-avatar-container">
          <div className="featured-avatar">
            {!selectedAvatar && (
              <img 
                src={featuredAvatarSrc} 
                alt="Featured Avatar" 
              />
            )}
            {selectedAvatar && (
              <div className="model-preview vrm-preview">
                <PreviewVRM avatar={selectedAvatar} />
                <div className="model-type-badge">VRM</div>
              </div>
            )}
          </div>
        </div>
        
        {/* Avatar Grid (Right side on desktop) */}
        <div className="avatar-inventory-container">
          <h2 className="inventory-title">Avatar Inventory</h2>
          <div className="avatar-grid">
            {avatars.map((avatar) => (
              <div
                key={avatar.id}
                className={`avatar-option ${selectedAvatar?.id === avatar.id ? 'selected' : ''}`}
                onClick={() => handleAvatarClick(avatar)}
              >
                <img src={avatarAssets.getAvatarIcon(avatar)} alt={`Avatar ${avatar.id}`} />
              </div>
            ))}
          </div>
          
          {/* Continue button - visible when avatar is selected */}
          {selectedAvatar && (
            <button 
              className="continue-btn"
              onClick={() => {
                trackEvent(ANALYTICS_EVENTS.CONTINUE_BUTTON_CLICK, {
                  selected_avatar: selectedAvatar?.id,
                  from_page: 'avatar_select',
                  timestamp: Date.now()
                });
                // selectedAvatar already has full URLs
                onAvatarSelect(selectedAvatar);
              }}
            >
              Continue
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AvatarSelectPage;
